const awsConfigDev = {
  aws_project_region: 'eu-west-2',
  aws_appsync_graphqlEndpoint:
    'https://goxiqnabxjbj3lavceir47stsy.appsync-api.eu-west-2.amazonaws.com/graphql',
  aws_appsync_region: 'eu-west-2',
  aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
  aws_cognito_identity_pool_id:
    'eu-west-2:a03dfdb4-f3dd-4318-b0f1-8bc22fd7d101',
  aws_cognito_region: 'eu-west-2',
  aws_user_pools_id: 'eu-west-2_noMjCZRiV',
  aws_user_pools_web_client_id: '2hh0spnfn9f3032hvip5ldgmlp',
  oauth: {
    domain: 'popp-develop.auth.eu-west-2.amazoncognito.com',
    scope: [
      'phone',
      'email',
      'openid',
      'profile',
      'aws.cognito.signin.user.admin'
    ],
    redirectSignIn: 'http://localhost:3000/,https://develop.joinpopp.com/',
    redirectSignOut: 'http://localhost:3000/,https://develop.joinpopp.com/',
    responseType: 'code'
  },
  auth0Logout: {
    Azuredirect: {
      domain: 'auth.sso.joinpopp.com',
      clientId: '3AcjdGtXbpD6r4PiGEsTAE5twgFFXcmZ'
    },
    Auth0: {
      domain: 'dev-bsetw3vw0ntzsmii.us.auth0.com',
      clientId: 'tu1gAb27WYIwmF26gMbxqar2hTpxs53a'
    }
  },
  federationTarget: 'COGNITO_USER_POOLS',
  aws_cognito_username_attributes: [],
  aws_cognito_social_providers: ['GOOGLE'],
  aws_cognito_signup_attributes: ['EMAIL'],
  aws_cognito_mfa_configuration: 'OFF',
  aws_cognito_mfa_types: ['SMS'],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: []
  },
  aws_cognito_verification_mechanisms: ['EMAIL']
};

// eslint-disable-next-line no-undef
module.exports = awsConfigDev;
